var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginDialog',{ref:"loginDialog",attrs:{"hide-overlay":"","open-with":_vm.openWith()}})
}
var staticRenderFns = []

export { render, staticRenderFns }